/**
 * Payment provider type enum
 */
export enum PaymentProviderType {
    SagePay = 'SagePay',
    Stripe = 'Stripe'
}
